module.exports = __webpack_public_path__ + "static/media/ice-hockey.e337fdb1.svg";